import { TAppFormError } from "../../../types/TAppFormError";
import Text from "../../atoms/form/Text";
import TableRow from "../../atoms/TableRow";
import STDoubleTextRow from "../../../assets/styles/molecules/formTableRow/doubleTextRow.module.scss";
import AlartMessages from "../../atoms/AlartMessages";
import validateFormRow from "../../../utils/form/validateFormRow";

type formProps<T> = {
  placeholder?: string;
  defaultValue?: string;
  formKey: T;
  hundleOnChange: (value: string) => void;
};

type Props<T> = {
  title: string;
  subTitle?: string;
  required?: boolean;
  leftForm: formProps<T>;
  rightForm: formProps<T>;
  errors: TAppFormError<T>[];
  setErrors: (errors: TAppFormError<T>[]) => void;
  isDisplay?: boolean;
  canChange?: boolean;
  maxLength?: number;
  pattern?: RegExp;
  patternText?: string;
};

const DoubleTextRow = <T,>({
  title,
  subTitle,
  required = false,
  leftForm,
  rightForm,
  errors,
  setErrors,
  isDisplay = true,
  canChange = true,
  maxLength,
  pattern,
  patternText,
}: Props<T>) => {
  const hundleChange = (
    input: string,
    formKey: T,
    hundleOnChange: (value: string) => void
  ) => {
    validateFormRow<T>({
      input,
      errors,
      setErrors,
      formKey,
      maxLength,
      pattern,
      patternText,
      required,
    });
    hundleOnChange(input);
  };

  if (!isDisplay) return <></>;
  return (
    <TableRow title={title} subTitle={subTitle} required={required}>
      <span>
        <Text
          className={
            canChange ? STDoubleTextRow.form_left : STDoubleTextRow.disable
          }
          name={title}
          defaultValue={leftForm.defaultValue}
          placeholder={leftForm.placeholder}
          onChange={(input) =>
            hundleChange(input, leftForm.formKey, leftForm.hundleOnChange)
          }
        />
      </span>
      <span>
        <Text
          className={
            canChange ? STDoubleTextRow.form_right : STDoubleTextRow.disable
          }
          name={title}
          defaultValue={rightForm.defaultValue}
          placeholder={rightForm.placeholder}
          onChange={(input) =>
            hundleChange(input, rightForm.formKey, rightForm.hundleOnChange)
          }
        />
      </span>

      {AlartMessages<T>({
        title: title,
        errors: errors,
        keys: [leftForm.formKey, rightForm.formKey],
      })}
    </TableRow>
  );
};

export default DoubleTextRow;
